import React from "react";
import './dininghall.css';

const Silwanedininghall = () => {
  return (
    <>
        <div className="transparentvaluecont">
          <h2>Our beautiful dining hall offers spectacular, panoramic views directly overlooking the Silwane Dam.</h2>
          <div className="masiyevaluemaincont">   
          </div>
        </div>
        
    </>
  );
};

export default Silwanedininghall;